import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './Login';
import PrivateRoute from './PrivateRoute';

const App = () => {
  const navigate = useNavigate();
  const [isSsoProcessing, setIsSsoProcessing] = useState(() =>
    new URLSearchParams(window.location.hash.substring(1)).has('ssoToken')
  );

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const ssoToken = hashParams.get('ssoToken');

    if (!ssoToken) {
      return;
    }

    let isActive = true;

    const validateSsoToken = async () => {
      try {
        const response = await fetch(
          'https://reportingservice.tcisigorta.com/api/v1/user/validatetoken',
          {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${ssoToken}`,
            },
          }
        );

        if (!isActive) {
          return;
        }

        // Token yalnızca Reporting servisi doğruladıktan sonra kaydedilir.
        if (response.ok) {
          localStorage.setItem('authToken', ssoToken);
          window.history.replaceState({}, document.title, '/');
          navigate('/', { replace: true });
        } else {
          window.history.replaceState({}, document.title, '/login');
          navigate('/login', { replace: true });
        }
      } catch {
        if (isActive) {
          window.history.replaceState({}, document.title, '/login');
          navigate('/login', { replace: true });
        }
      } finally {
        if (isActive) {
          setIsSsoProcessing(false);
        }
      }
    };

    validateSsoToken();

    return () => {
      isActive = false;
    };
  }, [navigate]);

  if (isSsoProcessing) {
    return <div>Oturum doğrulanıyor...</div>;
  }

  return (
    <div>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
  );
};

export default App;
